module.exports = __webpack_public_path__ + "fonts/DM_Sans-400-latin2.c15d94a.woff2";